import { ReactNode } from 'react';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Toast as EbscoToast } from '@ebsco-ui/ebsco-ui';

import { PropsWithClassName } from '@app/constants';

interface ToastProps {
  title: ReactNode;
  type: 'info' | 'success' | 'error';
  subTitle?: ReactNode;
  icon?: IconDefinition;
}

export const Toast = ({
  type,
  icon,
  title,
  subTitle,
  className,
}: PropsWithClassName<ToastProps>) => {
  const testIdBase = `toast-${type}`;
  const TitleTag = subTitle ? 'strong' : 'span';

  return EbscoToast(
    <div className={className} data-auto={testIdBase}>
      <TitleTag data-auto={`${testIdBase}-title`}>{title}</TitleTag>
      <span data-auto={`${testIdBase}-subtitle`}>{subTitle}</span>
    </div>,
    {
      type,
      icon,
      closeButton: false,
      closeButtonTitle: '',
    }
  );
};
